import { PageType } from 'Shared/State';
import { componentNames } from 'Shared/component-registry';
import StartPageViewModel from './StartPageViewModel.type';

type StartPageType = StartPageViewModel & PageType;

export default (currentPage: PageType): currentPage is StartPageType => {
  return currentPage.componentName === componentNames.Avensia_Common_Features_Start_StartPageViewModel;
};
